module.exports = __webpack_public_path__ + "img/TX.3fec18ab.svg";